import { createFileRoute, redirect } from '@tanstack/react-router';

// The app has no landing page; the bare base path goes to login.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/login' });
  },
});
